// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__1mzWC","row":"Node_row__rk8wV","label":"Node_label__28UZ2","footer":"Node_footer__38JaB"};